import { FormPage, FormPageAuthProperty, FormPageProperty } from 'shared';

export const convertFormPropertiesToArray = <
  T extends FormPageProperty | FormPageAuthProperty = FormPageProperty,
>(
  formPage: FormPage,
): T[] => {
  const { uiOrder, properties } = formPage;
  if (uiOrder == null || properties == null) {
    return [];
  }
  return uiOrder.map((propertyId) => properties[propertyId] as T);
};
